import React, { useContext } from 'react';
import useStyles from '../styles';
import { Box, Stack, Typography } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PropTypes from 'prop-types';
import { Loader } from '@alumni-ventures-group/react-shared/lib/components';
import formatValueAsUSD from '../../../../../shared/helpers/formatValueAsUSD';
import { PlanContext } from '../../context/PlanContext';

const InvestmentStats = ({
  firstDateOfInvestment,
  totalNumberOfInvestments,
  averageAnnualInvestment,
  isMobile,
  isLoading,
}) => {
  const classes = useStyles();
  const { planningConfig } = useContext(PlanContext);
  const itemStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: isMobile ? '0%' : '20%',
  };

  const renderStat = (icon, value, label) => (
    <Box style={itemStyle}>
      {icon}
      <div style={{ marginLeft: '5%', textAlign: 'left' }}>
        <Typography
          variant="h1ExtraLarge"
          component="h1"
          style={{ color: '#191919' }}
        >
          {value}
        </Typography>
        <Typography
          variant={isMobile ? 'h4' : 'h2'}
          component="h2"
          style={{ fontWeight: 400 }}
        >
          {label}
        </Typography>
      </div>
    </Box>
  );

  return (
    <Stack spacing={{ md: 3, lg: 10 }}>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: { xs: 'auto', sm: 'auto', md: '500px' },
          }}
        >
          <Loader />
        </Box>
      ) : (
        <>
          {renderStat(
            <EventAvailableIcon className={classes.icon} />,
            firstDateOfInvestment,
            planningConfig?.investmentSnapshot?.dateOfFirstInvestmentCopy ||
              'Date of First Investment'
          )}
          {renderStat(
            <BarChartIcon className={classes.icon} />,
            totalNumberOfInvestments,
            planningConfig?.investmentSnapshot?.totalNumberOfInvestmentsCopy ||
              'Total Investments'
          )}
          {renderStat(
            <AccountBalanceIcon className={classes.icon} />,
            `${formatValueAsUSD(averageAnnualInvestment)}`,
            planningConfig?.investmentSnapshot?.averageInvestmentPerYearCopy ||
              'Average Per Year'
          )}
        </>
      )}
    </Stack>
  );
};

InvestmentStats.propTypes = {
  firstDateOfInvestment: PropTypes.string,
  totalNumberOfInvestments: PropTypes.number,
  averageAnnualInvestment: PropTypes.number,
  isMobile: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
};

InvestmentStats.defaultProps = {
  isMobile: false,
};

export default InvestmentStats;
